/**
 * AuthContext — provides the current user to descendant components.
 *
 * The raw token is no longer in context: pages read it implicitly through the
 * api client (which reads tokenManager.getToken()). Only `user` is exposed here
 * so pages can gate actions by fleet_role without prop-drilling.
 */
import { createContext, useContext } from 'react'
import type { MeResponse } from '../api/client'

export interface AuthContextValue {
  user: MeResponse
}

export const AuthContext = createContext<AuthContextValue | null>(null)

/** useAuth — must be used inside an AuthContext.Provider. Throws if missing. */
export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthContext.Provider')
  return ctx
}
